import axios, { AxiosRequestConfig } from 'axios';
import { getCookie } from '../utils/cookie';
import { MessageError } from './types';

const deafultAxiosConfig = {
  withCredentials: true,
  withXSRFToken: true,
  timeout: 60000,
  headers: {
    'content-Type': 'application/json',
    Accept: '/',
    'Cache-Control': 'no-cache',
  },
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getAcessToken = (request: AxiosRequestConfig<unknown>) => {
  const accessToken = getCookie('_TOKEN_BFF');

  if (accessToken) {
    request.headers = {
      ...request.headers,
      Authorization: `Bearer ${accessToken}`,
    };
  }
  return request;
};

const handleError = (err: unknown) => {
  const statusMessages: Record<number, string> = {
    401: process.env.FRETEBRAS_LOGOUT_URL,
    409: MessageError.duplicated,
    422: MessageError.notFound,
    423: MessageError.notActive,
  };

  const status = err?.response?.status;

  if (status === undefined) {
    return Promise.reject(new Error(MessageError.undefined));
  }

  // eslint-disable-next-line no-prototype-builtins
  if (statusMessages.hasOwnProperty(status)) {
    if (status === 401) {
      window.location.assign(statusMessages[status]);
      return Promise.resolve();
    }
    return Promise.reject(new Error(statusMessages[status]));
  }

  return Promise.reject(err);
};

const bffApiService = axios.create({
  baseURL: process.env.BFF_URL,
  ...deafultAxiosConfig,
});

bffApiService.interceptors.request.use(
  (request) => getAcessToken(request),
  (err) => Promise.reject(err)
);

bffApiService.interceptors.response.use(
  (response) => response.data,
  (err) => handleError(err)
);

const truckerProfileApiService = axios.create({
  baseURL: process.env.BFF_TRUCKER_PROFILE_URL,
  ...deafultAxiosConfig,
});

truckerProfileApiService.interceptors.request.use(
  (request) => getAcessToken(request),
  (err) => Promise.reject(err)
);

truckerProfileApiService.interceptors.response.use(
  (response) => response.data,
  (err) => handleError(err)
);

const riskManagementApi = axios.create({
  baseURL: process.env.BFF_RISK_MANAGEMENT_URL,
  ...deafultAxiosConfig,
});

riskManagementApi.interceptors.request.use(
  (request) => getAcessToken(request),
  (err) => Promise.reject(err)
);

riskManagementApi.interceptors.response.use(
  (response) => response.data,
  (err) => handleError(err)
);

const contactListService = axios.create({
  ...deafultAxiosConfig,
  baseURL: process.env.BFF_CONTACT_LIST_URL,
});

contactListService.interceptors.request.use(
  (request) => getAcessToken(request),
  (err) => Promise.reject(err)
);

contactListService.interceptors.response.use(
  (response) => response.data,
  (err) => handleError(err)
);

export { bffApiService, truckerProfileApiService, riskManagementApi, contactListService };
